import { ID_REGISTER } from 'civil-status/components/shared/list-register';
import { CodeTypeAct } from 'civil-status/constants/code-type-act';
import { SectionVM } from 'civil-status/view-models/step-form';
import { DateTime } from 'luxon';
import { ModelEventoDTO } from 'shell/models/act-category-list';

export const transformerMatrimonioAttoNascitaSposa = (
  values?: ModelEventoDTO
): SectionVM | undefined => {
  const attoNascitaSposa = values?.datiEventoMatrimonio?.attoNascitaSposa;

  if (!attoNascitaSposa) {
    return;
  }

  const typeAct = Boolean(attoNascitaSposa?.idAnsc)
    ? CodeTypeAct.attoDigitale
    : CodeTypeAct.attoCartaceo;

  return {
    typeAct,
    actForm: {
      idAnsc: attoNascitaSposa?.idAnsc,
      dateAct: attoNascitaSposa?.dataformazione
        ? DateTime.fromISO(attoNascitaSposa?.dataformazione)
        : null,
      italian: attoNascitaSposa?.idComuneRegistrazione
        ? {
            municipality: {
              id: attoNascitaSposa?.idComuneRegistrazione || '',
              code: attoNascitaSposa?.idComuneRegistrazione
                ? Number.parseInt(attoNascitaSposa?.idComuneRegistrazione, 10)
                : undefined,
              description: attoNascitaSposa.nomeComuneRegistrazione || '',
              province: attoNascitaSposa.siglaProvinciaRegistrazione || '',
              idProvince: attoNascitaSposa.idProvinciaRegistrazione
                ? Number.parseInt(attoNascitaSposa.idProvinciaRegistrazione, 10)
                : undefined,
            },
          }
        : undefined,
      register: ID_REGISTER.NASCITA,
      year: attoNascitaSposa?.annoAtto || '',
      municipalNumber: attoNascitaSposa?.numeroatto || '',
      typeEvent: attoNascitaSposa?.idtipocontenuto || '',
      portion: attoNascitaSposa?.parte || '',
      serie: attoNascitaSposa?.serie || '',
      volume: attoNascitaSposa?.volume || '',
    },
  };
};
